// extracted by mini-css-extract-plugin
module.exports = {"userItem":"users_userItem__1MnD2","userPhoto":"users_userPhoto__1_En6","pagination":"users_pagination__3wI4e","selectedPage":"users_selectedPage__1mnwI"};